import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Dropdown, Avatar, Button, theme } from 'antd';
import {
  DashboardOutlined,
  UserOutlined,
  RobotOutlined,
  FileTextOutlined,
  TeamOutlined,
  CreditCardOutlined,
  SettingOutlined,
  FileSearchOutlined,
  BellOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth.js';
import './AdminLayout.css';

const { Header, Sider, Content } = Layout;

const menuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: '数据看板',
  },
  {
    key: '/users',
    icon: <UserOutlined />,
    label: '用户管理',
  },
  {
    key: '/avatars',
    icon: <RobotOutlined />,
    label: 'AI分身管理',
  },
  {
    key: '/ai',
    icon: <RobotOutlined />,
    label: 'AI编排平台',
    children: [
      { key: '/ai/scenarios', label: '场景' },
      { key: '/ai/prompts', label: '提示词' },
      { key: '/ai/models', label: '模型' },
      { key: '/ai/routes', label: '路由' },
      { key: '/ai/skills', label: 'Skills' },
      { key: '/ai/policies', label: 'Policy' },
      { key: '/ai/context-bundles', label: '上下文' },
      { key: '/ai/experiments', label: '实验' },
      { key: '/ai/traces', label: 'Trace' },
      { key: '/ai/shadow-audits', label: '审计' },
      { key: '/ai/playground', label: 'Playground' },
      { key: '/ai/psych-config', label: '心理配置' },
      { key: '/ai/psych-ops', label: '行为回流' },
      { key: '/ai/trust', label: 'Trust V2' },
    ],
  },
  {
    key: '/content',
    icon: <FileTextOutlined />,
    label: '内容审核',
    children: [
      { key: '/content/moments', label: '动态管理' },
      { key: '/content/messages', label: '消息监控' },
      { key: '/content/reports', label: '举报处理' },
    ],
  },
  {
    key: '/groups',
    icon: <TeamOutlined />,
    label: '群组管理',
  },
  {
    key: '/subscriptions',
    icon: <CreditCardOutlined />,
    label: '订阅管理',
    children: [
      { key: '/subscriptions/plans', label: '套餐配置' },
      { key: '/subscriptions/orders', label: '订单管理' },
    ],
  },
  {
    key: '/settings',
    icon: <SettingOutlined />,
    label: '系统配置',
    children: [
      { key: '/settings/general', label: '基础配置' },
    ],
  },
  {
    key: '/logs',
    icon: <FileSearchOutlined />,
    label: '系统日志',
    children: [
      { key: '/logs/operation', label: '操作日志' },
      { key: '/logs/login', label: '登录日志' },
      { key: '/logs/error', label: '错误日志' },
    ],
  },
];

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      danger: true,
    },
  ];

  const handleUserMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
    }
  };

  const getOpenKeys = () => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length > 1) {
      return [`/${pathParts[0]}`];
    }
    return [];
  };

  return (
    <Layout className="admin-layout">
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        width={240}
        className="admin-sider"
      >
        <div className="logo">
          {collapsed ? 'OYC' : 'OPENYC Admin'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={getOpenKeys()}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header className="admin-header" style={{ background: colorBgContainer }}>
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="collapse-btn"
            />
          </div>
          <div className="header-right">
            <Button type="text" icon={<BellOutlined />} />
            <Dropdown
              menu={{ items: userMenuItems, onClick: handleUserMenuClick }}
              placement="bottomRight"
            >
              <div className="user-info">
                <Avatar 
                  size="small" 
                  icon={<UserOutlined />}
                  style={{ backgroundColor: '#1890ff' }}
                />
                <span className="username">{user?.username || '管理员'}</span>
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content
          className="admin-content"
          style={{
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
